<hr>
<div
    *ngIf="macrotemi"
    class="row col-md-12"
>
    <div
        *ngFor="let m of macrotemi"
        [ngClass]="{'active': current_macrotema && current_macrotema == m}"
        class="col-md-4 container"
        (click)="current_macrotema = m"
    >
        <div class="row title">
            <div
                *ngIf="current_macrotema != m"
                class="col-md-2"
            ><img
                    width="32"
                    height="32"
                    src="{{getIcon(m)}}"
                ></div>
            <div
                *ngIf="current_macrotema == m"
                class="col-md-2"
            ><img
                    width="32"
                    height="32"
                    src="{{getActiveIcon(m)}}"
                ></div>
            <div class="col-md-10">
                <h5>{{m.nome.it}}</h5>
                {{m.sottotitolo.it}}
            </div>
        </div>
    </div>
</div>
<hr><br>
<div
    *ngIf="current_macrotema"
    class="row col-md-12"
>
    <br>
    <nb-accordion
        #item
        class="col-md-4"
        *ngIf="categorie_selected.length > 0"
    >
        <nb-accordion-item *ngFor="let c of categorie_selected">
            <nb-accordion-item-header
                [ngClass]="{'active': current_categoria && current_categoria == c}"
                (click)="current_categoria = c"
            >
                <h6 [ngClass]="{'active': current_categoria && current_categoria == c}">{{c.nome.it}}</h6>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
                <nb-list class="sottocategorie"><br>
                    <nb-list-item
                        [ngClass]="{'active': current_sottocategoria && current_sottocategoria == sc}"
                        *ngFor="let sc of sottocategorie_filtered"
                        (click)="current_sottocategoria = sc"
                    >
                        <div class="title">{{sc.nome.it}}</div>
                    </nb-list-item>
                </nb-list>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
    <faq
        class="col-md-8"
        [faqs]="filtered_faqs"
        [all_faqs]="faqs"
        [parole_chiave]="parole_chiave"
    ></faq>

</div>
